import { useMemo } from "react";
import { StatusCatalog } from "@interfaces/response";
import {
  STATUS_WAITING_ROOM,
  STATUS_BURO_BLOQUEADO,
  STATUS_ESPERANDO_OFERTA,
  STATUS_AVANCE_EXPEDIENTE_DIGITAL,
} from "../helpers/constantes";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";

interface UseTofuStepsReturn {
  numberOfSteps: number;
  currentStep: number;
}

const useTofuSteps = (currentStatus: string): UseTofuStepsReturn => {
  const statusConfig = useSelector((state: RootState) => state.app.status_config);

  const result = useMemo(() => {
    // statuses that should not be used in tofu steps
    const unusedStatus = [STATUS_WAITING_ROOM, STATUS_BURO_BLOQUEADO, STATUS_ESPERANDO_OFERTA];

    // Identify the index of the Waiting Room

    const indexWR = statusConfig.findIndex(
      (item: StatusCatalog) => item.code === STATUS_WAITING_ROOM || item.code === STATUS_AVANCE_EXPEDIENTE_DIGITAL,
    );
    const indexEO = statusConfig.findIndex((item: StatusCatalog) => item.code === STATUS_ESPERANDO_OFERTA);
    const index = indexWR !== -1 ? indexWR : indexEO;

    // Get statuses from index 0 to indexWR
    const statusBeforeWR = statusConfig.slice(0, index);

    // Remove unused statuses
    const tofuStatus = statusBeforeWR.filter((item: StatusCatalog) => !unusedStatus.includes(item.code));

    // get the number of steps and the current step
    const numberOfSteps = tofuStatus.length;

    // add 1 to the current step because the first step is registration
    const currentStep = tofuStatus.findIndex((item: StatusCatalog) => item.code === currentStatus) + 1;

    return {
      numberOfSteps,
      currentStep,
    };
  }, [statusConfig, currentStatus]);

  return result;
};

export default useTofuSteps;
